import { render } from "./Enigme2.vue?vue&type=template&id=2407ea6e"
import script from "./Enigme2.vue?vue&type=script&lang=js"
export * from "./Enigme2.vue?vue&type=script&lang=js"

import "./Enigme2.vue?vue&type=style&index=0&id=2407ea6e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__